import React from 'react';
import { cn } from '../../lib/cn';

export type BadgeVariant = 'gray' | 'red' | 'yellow' | 'green' | 'blue' | 'indigo' | 'purple';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
  icon?: React.ReactNode;
  dot?: boolean;
}

const base =
  'inline-flex items-center gap-1 px-2 py-0.5 rounded-full ' +
  'text-xs font-medium leading-none whitespace-nowrap';

const variantStyles: Record<BadgeVariant, string> = {
  gray:   'bg-gray-100 text-gray-700 dark:bg-zinc-800 dark:text-zinc-300',
  red:    'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950 dark:text-yellow-300',
  green:  'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300',
  blue:   'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300',
  indigo: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-950 dark:text-indigo-300',
  purple: 'bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-300',
};

const dotColors: Record<BadgeVariant, string> = {
  gray:   'bg-gray-400',
  red:    'bg-red-500',
  yellow: 'bg-yellow-500',
  green:  'bg-green-500',
  blue:   'bg-blue-500',
  indigo: 'bg-indigo-500',
  purple: 'bg-purple-500',
};

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'gray',
  className,
  icon,
  dot = false,
}) => {
  return (
    <span className={cn(base, variantStyles[variant], className)}>
      {dot && <span className={cn('h-1.5 w-1.5 rounded-full', dotColors[variant])} />}
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </span>
  );
};

export default Badge;
